// removed by extract-text-webpack-plugin
module.exports = {"red":"#e40000","black":"#000000","large":"_1DKjo7N8QvM6WqzxFcrV3K","carouselPagination":"-DHJUsRwiuz74pzSQG_6x","responsive":"_3tD9bDcvRliTssvYxAIFyc","dotsList":"EYRqHYtcVd1lpgz94FSOt","vertical":"_2eooUr5YoUEJilEJfN9R-K","dot":"_13fN7kONBJpWqDN0xeL2ev","circle":"_3b1hckvGF0WB11Cms2exOz","circleCenter":"_28EqrdEGsGm291vcG3Afm5","activeDot":"DXHrotFZUnh0vQ0Mpx-oE","autoplay":"druq9a36WxrQq5qzje2wp","dark":"_2vJXkkmv-jZpicldH8j2BJ","medium":"_3fF66KoV1ohymdbNcdHk9H"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/elements/Pagination/CarouselPagination/CarouselPagination.css
// module id = 989
// module chunks = 0